var map = {
  "./messages.pt.json": [
    "20986",
    "9735"
  ],
  "./messages.zh-Hant.json": [
    "7674",
    "7495"
  ],
  "./messages.en.json": [
    "81557",
    "4006"
  ],
  "./messages.ja.json": [
    "26955",
    "6456"
  ],
  "./messages.ko.json": [
    "10524",
    "7149"
  ],
  "./messages.zh-Hans.json": [
    "36503",
    "9660"
  ],
  "./messages.yahoo.en.json": [
    "60555",
    "9432"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 57033;
module.exports = webpackAsyncContext;
